import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";
import { Datepicker } from "@mobiscroll/react";
import { useAuth0 } from "@auth0/auth0-react";

import Stack from "@mui/material/Stack";

import { LoadingButton } from "../shared/loading-button";
import ai from "../../helpers/axios";

export const MetricsSalesFilters = ({ dates, owners, onChange, onApply, isLoading }) => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const loadOwnerOptions = useCallback(
    async (inputValue) => {
      const token = await getAccessTokenSilently().catch(() => {
        return loginWithRedirect();
      });

      const { data } = await ai.auth(token).get(`/api/users/roles/sales`, {});

      if (!data?.users?.length) return [];

      const options = data.users.map((user) => ({
        value: user.user_id,
        label: user.name,
        email: user.email,
      }));

      if (!inputValue) return options;

      const query = inputValue.toLowerCase();
      return options.filter((o) => o.label?.toLowerCase().includes(query));
    },
    [getAccessTokenSilently, loginWithRedirect]
  );

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      gap={3}
      my={3}
      className="metrics-utilization-filters"
    >
      <Stack flex={1}>
        <h6>SIGNED AT</h6>
        <Datepicker
          select="range"
          returnFormat="iso8601"
          controls={["date"]}
          value={dates}
          placeholder="__/__/____ - __/__/____"
          onChange={(range) => onChange({ dates: range.value })}
          themeVariant="light"
          inputProps={{
            readOnly: true,
            className: "dates-range-light-input",
          }}
          disabled={isLoading}
        />
      </Stack>

      <Stack flex={2}>
        <h6>OWNERS</h6>
        <AsyncSelect
          className="base-select"
          classNamePrefix="select"
          cacheOptions
          defaultOptions
          isMulti
          loadOptions={loadOwnerOptions}
          value={owners ?? []}
          onChange={(value) => onChange({ owners: value ?? [] })}
          placeholder="All owners"
          noOptionsMessage={() => "No owners"}
          isDisabled={isLoading}
        />
      </Stack>

      <LoadingButton
        className="base-button evo-blue"
        onClick={onApply}
        isLoading={isLoading}
        disabled={isLoading}
      >
        Apply
      </LoadingButton>
    </Stack>
  );
};
